<template>
    <div id="artShop">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=3></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <!-- <h3 class="app-title">{{ h3Intro }}</h3> -->
            <div class="hasline" v-for="(item, index) in arrList" :key="index">
                <div class="imgtxt ">
                    <img :src="item.image" alt="" class="pic" v-show="isMobile == 'PC' && index % 2 == 0 || isMobile == 'Mobile'">
                    <div class="txttxt">
                        <p v-html="item.content"></p>
                    </div>
                    <img :src="item.image" alt="" class="pic" v-show="isMobile == 'PC' && index % 2 != 0">
                </div>
            </div>

            <!-- <h3 class="app-title" v-if="ldList.length > 0">{{ h3Recommend }}</h3> -->
            <div class="hasline">
                <div class="list flex">
                    <div class="box hand" v-for="(item, index) in ldList" :key="index" @click="todetails(item.id)">
                        <img :src="item.image" alt="" class="pic">
                        <p class="tit">{{item.title}}</p>
                        <p class="price">￥{{ item.price }}</p>
                    </div>
                    <div class="box" v-if="arrList.length % 4 > 1"></div>
                    <div class="box" v-if="arrList.length % 4 == 2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { backheadTitles, pageLabels,imageurl } from "../utils/i18nLabels";
    import router from '@/router';
    const isMobile = localStorage.getItem('userAgent')


    const arrList = ref([]);
    const ldList = ref([]);
    const titleLabel = computed(() => backheadTitles.artShop[currentLanguage.value || 'zh'])
    const h3Intro = computed(() => pageLabels.artShop.intro[currentLanguage.value || 'zh'])
    const h3Recommend = computed(() => pageLabels.artShop.recommended[currentLanguage.value || 'zh'])
    // 跳详情
    function todetails(id) {
        router.push("/details?pid=10&id=" + id)
    }
    // 获取列表数据
    function getList() {
        let queryParams1 = {
            page: 1,
            pageSize: 100,
            pid: 4
        }
        getshowList(queryParams1).then(res => {
            const data = res.data
            data.list.map(item => {
                item.image = item.image ? imageurl + item.image : undefined
            })
            arrList.value = data.list;
        });
        let queryParams2 = {
            page: 1,
            pageSize: 100,
            pid: 10
        }
        getshowList(queryParams2).then(res => {
            const data = res.data
            data.list.map(item => {
                item.image = item.image ? imageurl + item.image : undefined
            })
            ldList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #artShop{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        text-align: left;
        .hasline{
            overflow: hidden;
            padding: 50px 60px;
        }
        h3{
            font-size: 30px;
            color: #232323;
            padding: 60px 50px 0;
            font-weight: normal;
        }
        .list{
            flex-wrap: wrap;
            margin: 0 0 40px;
            .box{
                width: 24%;
                margin-bottom: 50px;
                .pic{
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                }
                .tit{
                    font-size: 18px;
                    color: #000;
                    margin: 10px 0;
                }
                .price{
                    font-size: 18px;
                    color: #969696;
                }
            }
            .hand{
                cursor: pointer;
            }
        }
        .imgtxt{
            max-width: 814px;
            margin: 0 auto;
            /* align-items: flex-start; */
            img{
                width: 100%;
            }
            .txttxt{
                width: 100%;
            }
            p{
                color: #000;
                font-size: 18px;
            }
        }
    }


    .Mobileclass{
        margin-top: 160px;
        .flex{
            display: block;
        }
        .hasline{
            padding: 10px 22px;
            border: none;
            .imgtxt {
                display: block;
                
                img{
                    width: 100%;
                    display: block;
                    margin: 10px 0;
                }
                div{
                    width: 100%;
                }
                h5{
                    font-size: 28px;
                    margin: 20px 0;
                }
            }
        }
        .list{
            display: block;
            padding: 0;
            .box{
                width: 100%;
                padding: 0;
                margin-bottom: 30px;
                .tit{
                    font-size: 20px;
                    margin: 4px 0;
                }
            }
        }
        h3{
            padding: 22px;
            margin: 0;
            color: #232323;
        }
    }
    :deep(p) img {
    height: auto !important;
    max-width: 100% !important;
}
</style>